import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 5500;
const GAP_MS = 12000;

/**
 * Low-frequency "someone just bought this" notification, bottom-left so it
 * never covers the CTA. Dismissable, and it stops for the session once closed.
 */
export function PurchaseNotifications() {
  const reduceMotion = useReducedMotion();
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timeout = setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      timeout = setTimeout(() => {
        setIndex(i => (i + 1) % recentPurchases.length);
        show();
      }, GAP_MS);
    };
    timeout = setTimeout(show, FIRST_DELAY);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  if (dismissed) return null;
  const purchase = recentPurchases[index];
  const minutes = 2 + index * 7 % 26;
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6" data-id="element-182" data-mp="js5p2zip07mb">
      <AnimatePresence data-id="element-183" data-mp="1chutznyiwrt7">
        {visible && <motion.div key={index} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[320px] max-w-full items-start gap-3 rounded-xl border border-ice-dark bg-white p-3.5 shadow-card" data-id="element-184" data-mp="17k338x9m7bql">
            <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-185" data-mp="3ks3zqwox3znc">
              <CheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-186" data-mp="3pp485e98pehm" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-187" data-mp="3frg0xoug6eik">
              <p className="text-[13px] leading-snug text-ink" data-id="element-188" data-mp="3fq4vlklcsypc">
                <span className="font-bold" data-id="element-189" data-mp="31zrspwnbka6v">{purchase.name}</span> in{' '}
                {purchase.city}, {purchase.state} just got Cheer Coach Pro
              </p>
              <p className="mt-1 text-[11px] font-bold uppercase tracking-wide text-ink-muted" data-id="element-190" data-mp="36sunu97qvrp6">
                {minutes} minutes ago · Verified order
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notifications" className="-mr-1 -mt-1 flex h-7 w-7 flex-none items-center justify-center rounded-full text-ink-muted transition-colors duration-150 hover:bg-ice hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-191" data-mp="2wz40j7nctnb2">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-192" data-mp="1zi03zlqcprjh" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}